module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "解绑学导"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "assignAdviserForm",
    staticClass: "form",
    attrs: {
      "model": _vm.adviserParam,
      "rules": _vm.adviserRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.id + ' - ' + item.nickname) + "\n        ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAssignAdviser
    },
    on: {
      "click": _vm.assignAdviser
    }
  }, [_vm._v("解绑")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16515eb1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UnBinStudyModal.vue
// module id = 1663
// module chunks = 8